// import { disablePageScroll, enablePageScroll, addLockableTarget } from 'scroll-lock';
import {
    disableBodyScroll,
    enableBodyScroll,
    clearAllBodyScrollLocks
} from "body-scroll-lock";
import { mapActions, mapGetters } from "vuex";
import { arrayMax } from "highcharts";

let originScrollTop = 0;
export const padLeft = (len, str) => (val) => val.toString().padLeft(len, str);
export const commonMixin = {
    data() {
        return {
            isChecking: false,
            currentTab: 0,
            isScrolling: false
        };
    },
    computed: {
        ...mapGetters(["UserInfo"]),
        isBox() {
            // 判斷是否為 box
            return this.UserInfo.userType === "box";
        }
    },
    methods: {
        ...mapActions(["setPageLock"]),
        checkboxChange($event, name) {
            if (this.isChecking) return;

            let checked = $event.target.checked;
            let isAll = $event.target.value === "all";
            let item = this.form[name];
            this.isChecking = true;

            if (isAll && checked) {
                this.$el.querySelectorAll(`[name='${name}[]']`).forEach((el) => {
                    if (item.indexOf(el.value) === -1) {
                        item.push(el.value);
                    }
                });
            } else if (!isAll && !checked) {
                this.$el.querySelectorAll(`[name='${name}[]']`).forEach((el) => {
                    if (el.value === "all") el.checked = false;
                });

                this.form[name] = item.reduce((ary, value) => {
                    if (value !== "all") {
                        ary.push(value);
                    }
                    return ary;
                }, []);
            }
            this.isChecking = false;
        },
        getCurrentDate() {
            // 取得當前年月日
            let newDate = new Date();
            let month = newDate.getMonth() + 1 + "";
            let date = newDate.getDate() + "";
            if (month.length == 1) month = "0" + month;
            if (date.length == 1) date = "0" + date;
            return `${newDate.getFullYear()}-${month}-${date}`;
        },
        mixDateDiff(sDate1, sDate2) {
            //  計算兩日期相差天數
            // sDate1 = 開始日期  , sDate2 = 結束日期
            // 如果 sDate1、sDate2 傳 null 時開始時間為當前系統日期
            const ptDash = /^\d{3}\-/g;
            const ptSlash = /^\d{3}\//g;
            let oDate1, oDate2, iDays;
            let newDate = new Date();
            if (sDate1 == null) {
                oDate1 = new Date(
                    `${newDate.getFullYear()}/${newDate.getMonth() +
                    1}/${newDate.getDate()}`
                ).getTime();
            } else if (typeof sDate1 == "string") {
                if (ptDash.test(sDate1)) {
                    let dd = sDate1.split("-");
                    dd[0] = Number(dd[0]) + 1911;
                    dd = dd.join("-");
                    oDate1 = new Date(dd).getTime();
                } else if (ptSlash.test(sDate1)) {
                    let dd = sDate1.split("/");
                    dd[0] = Number(dd[0]) + 1911;
                    dd = dd.join("/");
                    oDate1 = new Date(dd).getTime();
                } else {
                    if (sDate1.includes("-")) {
                        oDate1 = new Date(sDate1.replace(/\-/g, "/")).getTime();
                    } else {
                        oDate1 = new Date(sDate1).getTime();
                    }
                }
            } else {
                oDate1 = new Date(
                    `${sDate1.getFullYear()}/${sDate1.getMonth() + 1}/${sDate1.getDate()}`
                ).getTime();
            }

            if (sDate2 == null) {
                oDate2 = new Date(
                    `${newDate.getFullYear()}/${newDate.getMonth() +
                    1}/${newDate.getDate()}`
                ).getTime();
            } else if (typeof sDate2 == "string") {
                if (ptDash.test(sDate2)) {
                    let dd = sDate2.split("-");
                    dd[0] = Number(dd[0]) + 1911;
                    dd = dd.join("-");
                    oDate2 = new Date(dd).getTime();
                } else if (/^\d{3}\//g.test(sDate2)) {
                    let dd = sDate2.split("/");
                    dd[0] = Number(dd[0]) + 1911;
                    dd = dd.join("/");
                    oDate2 = new Date(dd).getTime();
                } else {
                    if (sDate2.includes("-")) {
                        oDate2 = new Date(sDate2.replace(/\-/g, "/")).getTime();
                    } else {
                        oDate2 = new Date(sDate2).getTime();
                    }
                }
            } else {
                oDate2 = new Date(
                    `${sDate2.getFullYear()}/${sDate2.getMonth() + 1}/${sDate2.getDate()}`
                ).getTime();
            }
            iDays = parseInt((oDate2 - oDate1) / 1000 / 60 / 60 / 24); // 把相差的毫秒數轉換為天數
            return iDays;
        },
        panelOpen(name) {
            this[name] = true;
            document.querySelector('body').classList.add('modal-open');
        },
        panelClose(name) {
            return new Promise(resolve => {
                var open = document.querySelectorAll('.modal.is-open'),
                    elem = open[open.length - 1];
                if (elem) {
                    elem.className += ' is-out';
                    elem.classList.remove('is-out');
                }
                if (open && open.length >= 1) {
                    document.querySelector('body').classList.remove('modal-open');
                }
                this[name] = false;
            });
        },
        iOSversion() {
            var v = navigator.userAgent.match(/(Version\/\d+(\.\d+)*)/);
            if (typeof v !== "undefined" && v !== null) {
                return parseInt(v[0].split("/")[1]);
            } else {
                return 0;
            }
        },
        len(str) {
            return str.replace(/[^\x00-\xff]/g, "xx").length;
        },
        sub(str, n) {
            let l = 0;
            for (let i = 0; i < str.length; i++) {
                if (str[i].match(/[^\x00-\xff]/g)) {
                    l += 2;
                } else {
                    l++;
                }
                if (l >= n) {
                    return str.substr(0, i + 1);
                }
            }
        },
        truncate(str, n) {
            return this.len(str) > n ? this.sub(str, n) + "..." : str;
        },
        dateFormat(val, delimiter = "/") {
            // 轉換為民國
            if (val) {
                let dataAry = val.split("-");
                dataAry[0] = dataAry[0] * 1 - 1911 + "";
                return dataAry.join(delimiter);
            }
            return "";
        },
        // 使用localStorage儲存上一頁
        setHistory(currentRouterName, TargetRouterName) {
            if (!currentRouterName && !TargetRouterName) {
                return;
            }

            let history = localStorage.getItem("history");
            if (!history) {
                history = {};
            } else {
                history = JSON.parse(history);
            }

            history[TargetRouterName] = currentRouterName;
            localStorage.setItem("history", JSON.stringify(history));
        },
        // 取得儲存在localStorage的上一頁資訊
        getHistory(currentRouterName) {
            let history = localStorage.getItem("history");
            if (!history) {
                return;
            }

            history = JSON.parse(history);

            let backRouterName = "";
            if (history[currentRouterName]) {
                backRouterName = history[currentRouterName];
                delete history[currentRouterName];
                localStorage.setItem("history", JSON.stringify(history));
            }

            return backRouterName;
        },
        // 清除所有頁面的上一頁資訊
        clearHistory() {
            localStorage.removeItem("history");
        },
        //傳入年度與當天的月分和日期取得該年對應的日期
        fixYear(year, thisMonth, thisDay) {
            // 畫面不用顯示日期，邏輯註解，日後BU需求有異動再打開
            // let thisDate = new Date(parseInt(year) + 1911, thisMonth - 1, thisDay);
            // const thisDateMonth = thisDate.getMonth() + 1;
            // const thisDateDay = thisDate.getDate();
            // if (thisDateMonth != this.thisMonth) {
            //   thisDate.setDate(thisDateDay - 1);
            // }
            // return thisDate.getFullYear() - 1911 + '年' + this.formateZero(thisDate.getMonth() + 1) + '月' + this.formateZero(thisDate.getDate()) + '日';
            return year + '年';
        },
        formateZero(num) {
            return parseInt(num) < 10 ? '0' + num : num;
        },
        //清除特殊字元 (exclude為排除清除的字元(ex: '@()_')，若無exclude則排除所有特殊字元)
        cleanSpecialChar(val, exclude) {
            if (exclude) {
                return val.replace(new RegExp('[^a-zA-Z0-9\u4E00-\u9FA5' + exclude + ']', 'g'), '');
            }
            return val.replace(/[^a-zA-Z0-9\u4E00-\u9FA5]/g, '');
        },
        //計算字元長度 (字串, 是否檢查, 檢查的長度) 
        stringBytes(c, isSub, size) {
            var n = c.length,
                s;
            var len = 0;
            for (var i = 0; i < n; i++) {
                s = c.charCodeAt(i);
                while (s > 0) {
                    len++;
                    s = s >> 8;
                    if (isSub && len > size) {
                        return i;
                    }
                }
            }
            return len;
        },
        //回傳限制字元後的長度+...
        getTruncateText(val, limit, hasDot) {
            if (!val || !limit) {
                return '';
            }
            if (this.stringBytes(val, false, limit) > limit) {
                if (hasDot) {
                    return val.substr(0, 6) + '...';
                } else {
                    return val.substr(0, 6);
                }
            } else {
                return val;
            }
        },
        //客戶個人資訊頁面導頁功能，回傳給APP端所需參數
        boxCustInfo(csid, csname) {
            this.$nextTick(() => {
                if (window.webkit) {
                    let custObj = {
                        CSIDNO: csid ? csid : "",
                        CSNAME: csname ? csname : ""
                    };
                    window.webkit.messageHandlers.sendCustomerInfo.postMessage(
                        JSON.stringify(custObj)
                    );
                }
            });
        },
        //產險客戶個人資訊頁面導頁功能，回傳給APP端所需參數
        boxPropertyCustInfo(csid, csname) {
            this.$nextTick(() => {
                if (window.webkit) {
                    let custObj = {
                        CSIDNO: csid ? csid : "",
                        CSNAME: csname ? csname : ""
                    };
                    window.webkit.messageHandlers.sendPropertyCustomerInfo.postMessage(
                        JSON.stringify(custObj)
                    );
                }
            });
        },
        //客戶個人資訊頁面導頁功能，回傳給APP端所需參數
        boxCustInfoUpdate(csid, csname) {
            this.$nextTick(() => {
            if (window.webkit) {
                let custObj = { 
                    CSIDNO: csid ? csid : "", 
                    CSNAME: csname ? csname : "" 
                };
                window.webkit.messageHandlers.updateCustomerInfo.postMessage(
                    JSON.stringify(custObj)
                );
                }
            });
        },
        //檔案下載功能，回傳給APP端所需參數
        boxDownload(fileName, serNo) {
            this.$nextTick(() => {
                if (window.webkit) {
                    let fileObj = {
                        FileName: fileName ? fileName : "",
                        Ser_no: serNo ? serNo : ""
                    };
                    window.webkit.messageHandlers.sendPdfFile.postMessage(
                        JSON.stringify(fileObj)
                    );
                }
            });
        },
        //chrome瀏覽器直接下載檔案
        chromeDonloadFile(blob, filename, windows) {
            let a = document.createElement('a');
            document.body.appendChild(a);
            let url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            a.click();
            setTimeout(() => {
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }, 0);
            if (windows) {
                windows.close();
            }
        },
        isIpad() {
            if (/iPad|iPhone|iPod/.test(navigator.platform)) {
                return true;
            } else {
                // 部分 iPadPro 會顯示為 MacIntel
                return (
                    navigator.maxTouchPoints &&
                    navigator.maxTouchPoints > 2 &&
                    /MacIntel/.test(navigator.platform)
                );
            }
        },
        isSafari() {
            return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        },
        // 判斷是否在webView開啟
        isWebView() {
            const ua = navigator.userAgent;
            const isWebView = /WebView|wv/.test(ua);
            return isWebView || (this.isIpad() && this.isBox);
        },
        // 一般瀏覽器列印報表需開新視窗
        openNewWindow() {
            let newWindow = window.open('');
            newWindow.document.write('<html style="height: 100%;">');
            newWindow.document.write('<head>');
            newWindow.document.write('<meta name="viewport" content="width=device-width, minimum-scale=0.1">');
            newWindow.document.write('<title>MV PDF LOADING...</title>');
            newWindow.document.write('</head>');
            newWindow.document.write('<body style="margin: 0px; background: #0e0e0e; height: 100%">');
            newWindow.document.write(
                '<div><img style="position: absolute;top: 0;bottom: 0;left: 0;right: 0;margin: auto;" src="/crm/assets/common/mv-pdf-loader.gif"></div>'
            );
            newWindow.document.write('</body></html>');
            return newWindow;
        },
        // webView開啟將檔案傳送給app method
        sendPdfDataToApp(file, filename) {
            if (this.isWebView()) {
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onloadend = () => {
                    let base64data = 'fileName:' + filename + ';' + reader.result;
                    window.webkit.messageHandlers.getBase64PdfData.postMessage(JSON.stringify(base64data));
                };
            }
        },
        //連至Box排訪
        boxVisit(data, categoryInfo) {
            this.$nextTick(() => {
                if (window.webkit) {
                    let visitObj = {
                        CSIDNO: data.id ? data.id : "",
                        EVENT_YEAR: data.visit.event_year ? data.visit.event_year : "",
                        EVENT_SER_NO: data.visit.event_ser_no ? data.visit.event_ser_no : "",
                        LIST_NO: categoryInfo.ser_no ? categoryInfo.ser_no : "",
                        LIST_NAME: categoryInfo.category ? categoryInfo.category : ""
                    };
                    window.webkit.messageHandlers.customerAppointment.postMessage(
                        JSON.stringify(visitObj)
                    );
                }
            });
        },
        //連至 Box 申辦項目
        boxServiceItem(data) {
            this.$nextTick(() => {
                if (window.webkit) {
                    let serviceItemObj = {
                        linkApp: data.linkApp || '',
                        linkUrl: data.linkUrl || '',
                        itemType: data.itemType || '',
                        itemTitle: data.itemTitle || ''
                    };
                    window.webkit.messageHandlers.linkHubApp.postMessage(
                        JSON.stringify(serviceItemObj)
                    );
                }
            });
        },
        //將產iReport報表所需資訊回傳至Box (異動後實質接觸明細)
        boxPostMailFile(url, printSe, formData, agid) {
            this.$nextTick(() => {
                if (window.webkit) {
                    let printObj = {
                        API_URL: url ? url : "",
                        PRINT_SE: printSe ? printSe : "",
                        FORMDATA: formData ? formData : "",
                        AGID: agid ? agid : ""
                    };
                    window.webkit.messageHandlers.sendPostMailFile.postMessage(
                        JSON.stringify(printObj)
                    );
                }
            });
        },
        //將產iReport報表所需資訊回傳至Box (國泰一家人名單)
        boxCathayFamilyFile(url, idNo, name, mobile, email, applyNo) {
            this.$nextTick(() => {
                if (window.webkit) {
                    let printObj = {
                        API_URL: url ? url : "",
                        CSIDNO: idNo ? idNo : "",
                        NAME: name ? name : "",
                        MOBILE: mobile ? mobile : "",
                        EMAIL: email ? email : "",
                        APPLY_NO: applyNo ? applyNo : ""
                    };
                    window.webkit.messageHandlers.sendCathayFamilyFile.postMessage(
                        JSON.stringify(printObj)
                    );
                }
            });
        },
        //將分享連結網址回傳至Box
        boxCathayShareLink(link) {
            this.$nextTick(() => {
                if (window.webkit) {
                    let linkObj = {
                        MESSAGE: link ? link : ""
                    };
                    window.webkit.messageHandlers.sendCathayAppShareLink.postMessage(
                        JSON.stringify(linkObj)
                    );
                }
            });
        },
        // //客戶標籤附件下載功能，回傳給APP端所需參數
        // boxDownloadTagFile(tagID, fileName) {
        //     this.$nextTick(() => {
        //         if (window.webkit) {
        //             let tagObj = {
        //                 TAG_ID: tagID ? tagID : "",
        //                 FILE_NAME: fileName ? fileName : ""
        //             };
        //             window.webkit.messageHandlers.sendCusTagFile.postMessage(
        //                 JSON.stringify(tagObj)
        //             );
        //         }
        //     });
        // },
        //回傳邀請函網址(圖檔)
        boxSendUrlString(url) {
            this.$nextTick(() => {
                if (window.webkit) {
                    let urlObj = { urlString: url ? url : "" };
                    window.webkit.messageHandlers.sendUrlString.postMessage(
                        JSON.stringify(urlObj)
                    );
                }
            });
        },
        //下載報表
        boxDownloadIReport(url, param) {
            this.$nextTick(() => {
                if (window.webkit) {
                    let Obj = {
                        URL: url ? url : "",
                        PARAM: param ? param : ""
                    };
                    window.webkit.messageHandlers.downloadIReport.postMessage(
                        JSON.stringify(Obj)
                    );
                }
            });
        },
        //傳遞base64格式資料給APP
        boxSendBase64PdfData(buffer) {
            this.$nextTick(() => {
                if (window.webkit) {
                    // let str = String.fromCharCode.apply(null, new Uint8Array(buffer));
                    let str = "";
                    let chunk = 8 * 1024;
                    let i;
                    let array = new Uint8Array(buffer);
                    for (i = 0; i < array.length / chunk; i++) {
                        str += String.fromCharCode.apply(null, array.slice(i * chunk, (i + 1) * chunk));
                    }
                    str += String.fromCharCode.apply(null, array.slice(i * chunk));
                    window.webkit.messageHandlers.getBase64PdfData.postMessage(btoa(str));
                }
            });
        },
        //向左補符號(傳入的值, 長度限制, 要串接的符號)
        paddingLeft(val, length, symbol) {
            if (val && val.length >= length) {
                return val;
            }
            for (let i = 0; i < length; i++) {
                if (val.length == length) {
                    break;
                }
                val = symbol + val;
            }
            return val;
        },
        //欄位排序
        sortCompareFun(sortOrder, property) {
            return function (a, b) {
                let result =
                    a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
                return result * sortOrder;
            };
        },
        //傳遞高齡投保評估量表網址給APP
        boxOpenSurvey(url) {
            if (this.isWebView()) {
                this.$nextTick(() => {
                    if (window.webkit) {
                        window.webkit.messageHandlers.openSurvey.postMessage(url);
                    }
                });
            }
        },
        //BFF uri轉換
         convertUri(uri) {
            // 分割路徑取得各段
            const pathSegments = uri.split('/').filter(s => s);
            
            // 檢查倒數第二個路徑段是否需要排除
            if (pathSegments.length >= 2) {
                const secondLastSegment = pathSegments[pathSegments.length - 2];
                const prefix = secondLastSegment.substring(0, 2);
                
                // 針對不同前綴做不同處理
                if (prefix !== 'MX' && prefix !== 'MV') {
                    // 如果是保健報表列印，不處理uri
                    if (uri.startsWith('/servlet/HttpDispatcher/DOWNLOAD_FILE_API2')) {
                        return uri;  // 不處理，返回原URL
                    }
                    
                    // 如果是 RestApiAdapter 且不是 MX/MV 開頭，只替換前綴（不移除底線）
                    if (uri.startsWith('/RestApiAdapter/')) {
                        return uri.replace('/RestApiAdapter/', '/api/v1/');
                    }
                }
            }
            // 處理轉換
            // 1. 先替換前綴
            let newUri = uri.replace(/^\/servlet\/HttpDispatcher\/|^\/RestApiAdapter\//, "/api/v1/");
            
            // 2. 分割新的 URI
            const parts = newUri.split('/');
            
            // 3. 移除底線，只處理主程式名稱的底線（不處理方法名稱）
            if (parts.length >= 2) {
                // 處理除了最後一個以外的所有部分
                for (let i = 0; i < parts.length - 1; i++) {
                    parts[i] = parts[i].replace(/_/g, '');
                }
            }
            return parts.join('/');
        }
    },
    mounted() {
        const { $ } = window;
        $('[data-toggle="tab"]').on("shown.bs.tab", (e) => {
            let li = $(e.target).closest(".nav-item");
            this.currentTab = $('ul[role="tablist"] > li').index(li);

            if (li.className == "dropdown-item") {
                let link = li.querySelector("a");
                $(e.target).attr("aria-selected", false);
                $(e.target).removeClass("active show");
                $(link).addClass("active show");
            }
        });
    }
};